import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Deterministic colour from a name (used by Avatar initials).
export function hashColor(input: string): string {
  return avatarColors(input).bg
}

/**
 * Pair of (background, foreground) colors for an avatar, keyed by the first
 * letter of the provided name. Falls back to the primary blue tint.
 */
export function avatarColors(input: string): { bg: string; fg: string } {
  const letter = (input.trim()[0] ?? '').toUpperCase()
  if (letter >= 'A' && letter <= 'D') return { bg: '#EFF6FF', fg: '#2B8FD4' }
  if (letter >= 'E' && letter <= 'H') return { bg: '#F0FDF4', fg: '#16A34A' }
  if (letter >= 'I' && letter <= 'L') return { bg: '#FFF7ED', fg: '#EA580C' }
  if (letter >= 'M' && letter <= 'P') return { bg: '#FAF5FF', fg: '#9333EA' }
  if (letter >= 'Q' && letter <= 'T') return { bg: '#FFF1F2', fg: '#E11D48' }
  if (letter >= 'U' && letter <= 'Z') return { bg: '#FFFBEB', fg: '#D97706' }
  return { bg: '#EFF6FF', fg: '#2B8FD4' }
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '·'
  if (parts.length === 1) return parts[0]![0]!.toUpperCase()
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
}
